import config from './config'
// TODO: ssr中获取host, 不支持 feature-[domain]
const host = process.client ? location.host : 'pan.xunlei.com'
const diffHostInfo = {
  'pan.xunlei.com': {
    clientId: 'Xqp0kJBXWhwaTpB6',
    packageName: 'pan.xunlei.com',
    signKey: 'k&&9(rT5LU',
    algVersion: '1',
    funName: 'pubLKU8HAmU2mgIFJDnQRmTKk48oVL0cZND',
    funFile: 'util',
  },
  'pan.xlpan.com': {
    clientId: 'XseEZG9_7KHMCmS1',
    packageName: 'pan.xlpan.com',
    signKey: 'DAtPW+E27N',
    algVersion: '1',
    funName: 'BEGIN_FUN_NAME_XLPAN',
    funFile: 'BEGIN_FUN_FILE_XLPAN',
  },
}

export const xlUserApis = {
  test: 'https://dev-xluser-ssl.xunlei.com',
  prod: 'https://xluser-ssl.xunlei.com',
}

const logLevel = config.driveAPI === 'prod' ? '' : ''
const isLoginNew = Math.floor(Math.random() * 100) > 0
const authorizePage = isLoginNew
  ? 'https://i.xunlei.com/center/account/personal/oauth/'
  : 'https://i.xunlei.com/xluser/oauth.html'

export default {
  apiOrigin: xlUserApis[config.driveAPI],
  clientId: diffHostInfo[host].clientId,
  packageName: diffHostInfo[host].packageName,
  signKey: diffHostInfo[host].signKey,
  algVersion: diffHostInfo[host].algVersion,
  authorizePage,
  scope: 'profile offline pan sso user',
  funName: diffHostInfo[host].funName,
  funFile: diffHostInfo[host].funFile,
  logLevel: logLevel,
  isLoginNew,
}
